import dayjs from 'dayjs';
import { calculateDaysDifference } from 'views/FuelAnalytics/IdleDashboard/utils';

export const formatStartEndDate = (
  rangeSelected: string,
  startDate?: Date | null,
  endDate?: Date | null
) => {
  let startApiDate = dayjs().subtract(1, 'day').toDate();
  const endApiDate = dayjs().subtract(1, 'day').toDate();

  switch (rangeSelected) {
    case 'Today': {
      return {
        startApiDate: dayjs().toDate(),
        endApiDate: dayjs().toDate(),
      };
    }

    case '1D':
      break;
    case '7D': {
      startApiDate = dayjs().subtract(7, 'day').toDate();
      break;
    }
    case '14D': {
      startApiDate = dayjs().subtract(14, 'day').toDate();
      break;
    }
    case '1M': {
      startApiDate = dayjs().subtract(1, 'month').toDate();
      break;
    }
    case 'Custom': {
      if (startDate && endDate) {
        return {
          startApiDate: dayjs(startDate).toDate(),
          endApiDate: dayjs(endDate).toDate(),
        };
      }
      return null;
    }

    default:
      break;
  }
  return { startApiDate, endApiDate };
};

export const showDailyData = (startDate: Date, endDate: Date) => {
  const daysDiff =
    startDate && endDate ? calculateDaysDifference(startDate, endDate) : 0;
  const shouldShowDailyData = daysDiff > 14;
  return shouldShowDailyData;
};
